import _sfc_main from "./InviteControl.vue2.mjs";
/* empty css                    */
import normalizeComponent from "../../_virtual/_plugin-vue2_normalizer.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _setup.inviteControlConfig.visible ? _c("div", { directives: [{ name: "click-outside", rawName: "v-click-outside", value: _setup.handleClickOutSide, expression: "handleClickOutSide" }], staticClass: "invite-control-container" }, [_c(_setup.IconButton, { staticClass: "invite", attrs: { "is-active": _setup.sidebarName === "invite", "title": _setup.t("Invite"), "icon": _setup.InviteIcon }, on: { "click-icon": _setup.toggleInviteSidebar } }), !_setup.isMobile && _setup.isShowInviteTab ? _c(_setup.roomInvite, { ref: "inviteRef" }) : _vm._e()], 1) : _vm._e();
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "5b059127"
);
const InviteControl = __component__.exports;
export {
  InviteControl as default
};
